module.exports = __webpack_public_path__ + "static/media/email.f63de5f5.png";